import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import LanguageSwitcher from "@/components/site/LanguageSwitcher";
import Home from "@/pages/Home";
import PostDetail from "@/pages/PostDetail";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEditor from "@/pages/AdminEditor";
import About from "@/pages/About";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen flex flex-col" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <LanguageSwitcher />
          <SiteNav />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/stories" element={<Home filterType="story" />} />
              <Route path="/poems" element={<Home filterType="poem" />} />
              <Route path="/about" element={<About />} />
              <Route path="/p/:slug" element={<PostDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/new" element={<AdminEditor />} />
              <Route path="/admin/edit/:id" element={<AdminEditor />} />
            </Routes>
          </main>
          <SiteFooter />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
